<template>
  <div class="form-upload">
    <div class="image-list">
      <div class="preview-item" v-for="(item, index) in fileList" :key="index">
        <el-image :src="item.url" :style="{ width: '100px', height: '100px' }" :preview-src-list="[item.url]" alt="图片"
          class="preview-image">
        </el-image>
        <i class="el-icon-error" @click="handleRemove(item, index)"></i>
      </div>
      <el-upload class="uploader" :action="action" :on-change="handleChange" :before-upload="beforeUpload"
        :data="uploadData" :http-request="customUpload" :show-file-list="false" :disabled="disabled"
        v-if="fileList.length < limit" ref="upload">
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </div>
    <div class="upload-tip" v-if="tip">{{ tip }}</div>
  </div>
</template>

<script>
import { uploadAliOSS } from '@/utils/upload'

export default {
  name: 'FormUpload',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    action: {
      type: String,
      default: ''
    },
    uploadData: {
      type: Object,
      default: () => ({})
    },
    limit: {
      type: Number,
      default: 5
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tip: {
      type: String,
      default: ''
    },
    bizType: {
      type: String,
      default: 'wmsAbnormalImage'
    },
    path: {
      type: String,
      default: 'wms/abnormal/'
    }
  },
  data() {
    return {
      fileList: [],
      loading: false
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val && val.length) {
          this.fileList = val.map(item => {
            if (typeof item === 'string') {
              return { url: item }
            }
            return item
          })
        } else {
          this.fileList = []
        }
      },
      immediate: true,
      deep: true
    },
    fileList(val) {
      console.log('fileList:', val);
    }
  },
  methods: {
    beforeUpload(file) {
      // 可以在这里添加文件类型、大小限制
      const isImage = file.type.indexOf('image/') !== -1
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!')
        return false
      }

      this.loading = true
      return true
    },
    handleChange(file, fileList) {
      // 可以在这里处理文件变化
      console.log('文件变化:', file, fileList)
    },
    customUpload({ file }) {
      this.loading = true

      // 使用 uploadAliOSS 上传到阿里云
      uploadAliOSS({
        file: file,
        path: this.path,
        bizType: this.bizType
      }).then(res => {
        if (res && res.url) {
          const newFile = {
            name: file.name,
            url: res.url
          }
          this.fileList.push(newFile)
          const newFileList = this.fileList.map(item => item.url)
          this.$emit('input', newFileList)
          this.$emit('upload-success', newFile)
        }
      }).catch(err => {
        this.$message.error('上传失败: ' + err.message)
        this.$emit('upload-error', err)
      }).finally(() => {
        this.loading = false
      })
    },
    handleRemove(file, index) {
      this.fileList.splice(index, 1)
      const newFileList = this.fileList.map(item => item.url)
      this.$emit('input', newFileList)
      this.$emit('remove', file, index)
      this.$message.success('删除成功')
    },
    // 对外暴露的清空方法
    clearFiles() {
      this.fileList = []
      this.$emit('input', [])
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles()
      }
    }
  }
}
</script>

<style scoped>
.form-upload {
  width: 100%;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
}

.preview-item {
  width: 100px;
  height: 100px;
  margin: 5px;
  position: relative;
}

.preview-item .el-icon-error {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
  color: #F56C6C;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 0 0 0 8px;
  padding: 2px;
}

.uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  height: 100px;
  width: 100px;
  margin: 5px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: border-color 0.3s;
}

.uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}
</style>